module.exports = __webpack_public_path__ + "ci_vendor_niffler.aefd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_niffler.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_niffler.svg
// module chunks = main